export const QA_NAME_CONFIG_MODAL = 'TableConfig'

export const QA_NAME_SELECT_ALL = 'SelectAll'
